/**
 * Public Booking Service
 * API methods for the public booking form (no authentication required)
 */

import api from './api';

const bookingPublicService = {
  /**
   * Get organization config for booking page
   * @param {string} orgCode - Organization code (e.g., 'ahac')
   */
  getOrgConfig: async (orgCode) => {
    const response = await api.get(`/v1/booking/${orgCode}/config/`);
    return response.data;
  },

  /**
   * Get available services for booking
   * @param {string} orgCode - Organization code
   */
  getServices: async (orgCode) => {
    const response = await api.get(`/v1/booking/${orgCode}/services/`);
    return response.data;
  },

  /**
   * Get available locations for booking
   * @param {string} orgCode - Organization code
   */
  getLocations: async (orgCode) => {
    const response = await api.get(`/v1/booking/${orgCode}/locations/`);
    return response.data;
  },

  /**
   * Get available time slots for booking
   * @param {string} orgCode - Organization code
   */
  getTimeSlots: async (orgCode) => {
    const response = await api.get(`/v1/booking/${orgCode}/time-slots/`);
    return response.data;
  },

  /**
   * Lookup vehicle details from DVLA
   * @param {string} registration - UK vehicle registration
   */
  lookupVehicle: async (registration) => {
    const cleanReg = registration.toUpperCase().replace(/\s/g, '');
    const response = await api.get(`/v1/booking/vehicle-lookup/${cleanReg}/`);
    return response.data;
  },

  /**
   * Get terms and conditions
   * @param {string} orgCode - Organization code
   */
  getTerms: async (orgCode) => {
    const response = await api.get(`/v1/booking/${orgCode}/terms/`);
    return response.data;
  },

  /**
   * Create a booking
   * @param {string} orgCode - Organization code
   * @param {object} bookingData - Booking form data
   */
  createBooking: async (orgCode, bookingData) => {
    const response = await api.post(`/v1/booking/${orgCode}/create/`, bookingData);
    return response.data;
  },
};

export default bookingPublicService;
